














































































































import BaseComponent from '@/components/base-component.vue';
import PendingPrescriptionForm from '@/components/pending-prescriptions/pending-prescription-form.vue';
import PendingPrescriptionWhatsappModal from '@/components/pending-prescriptions/pending-prescription-whatsapp-modal.vue';
import PendingPrescriptionStatusChip from '@/components/pending-prescriptions/pending-prescription-status-chip.vue';
import PendingPrescriptionTable from '@/components/pending-prescriptions/pending-prescription-table.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiAutocomplePatients from '@/components/UI/autocomplete-patients.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import { getServerISODate } from '@/helpers/dateFormat';
import { PendenciaPrescricaoFiltroDTO } from '@/interfaces/pending-prescriptions';
import * as service from '@/services/pending-prescriptions';
import Component from 'vue-class-component';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiDatePicker,
    UiAutocompleClientsSubsidiaries,
    UiAutocomplePatients,
    UiDatePickerRange,
    UiSelectDoctor,
    PendingPrescriptionForm,
    PendingPrescriptionStatusChip,
    PendingPrescriptionTable,
    PendingPrescriptionWhatsappModal
  }
})
export default class PendingPrescription extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;

  unidade = null;
  paciente = null;
  idMedico = null;
  datas = [getServerISODate(), getServerISODate()];
  statusSelec = [];
  statusesHistorico = false;
  SITUACAO_PENDENTE = 'PENDENTE';
  SITUACAO_EXPIRADO = 'EXPIRADO';
  situacao = this.SITUACAO_PENDENTE;
  prescLinkWa = false;

  statusListLoading = false;
  statusList = [];
  public id: Number = null;
  private filtros: PendenciaPrescricaoFiltroDTO = new PendenciaPrescricaoFiltroDTO();


  interval = null;
  scrollY = null;

  whatsappFormOpen = false;
  whatsappItem = null;

  private mounted(): void {
    this.loadStatusList();
    this.search();

    this.interval = setInterval(() => {
      this.scrollY = document.body.scrollTop;
      this.search(true);
    }, 60000);
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  loadStatusList() {
    this.statusListLoading = true;
    service.listPendingPrescriptionStatusFilter().subscribe(
      (res) => {
        this.statusListLoading = false;
        this.statusList = res;
      },
      (error) => {
        this.statusListLoading = false;
        this.showToastApiError(error);
      }
    );
  }

  private onChangeSearch() {
    this.search(false);
  }

  silent = false;
  private search(silent = false) {
    this.filtros.dataDe = this.datas[0];
    this.filtros.dataAte = this.datas[1];
    this.filtros.idUnidade = this.unidade ? this.unidade.id : null;
    this.filtros.idPaciente = this.paciente ? this.paciente.id : null;
    this.filtros.idMedico = this.idMedico;
    this.filtros.situacao = this.situacao;
    this.filtros.statuses = this.statusSelec;
    this.filtros.statusesHistorico = this.statusesHistorico;
    this.filtros.prescritoViaWaLink = this.prescLinkWa;


    this.filtros = Object.assign(new PendenciaPrescricaoFiltroDTO(), this.filtros);
    this.silent = silent;
  }

  private onEditItem(id): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = id;
  }

  private closeForm(): void {
    this.formOpen = false;
    this.id = null;
  }

  onListChange() {
    if (this.scrollY) {
      setTimeout(() => {
        document.body.scrollTo(0, this.scrollY);
      }, 100);
    }
  }

  private openWhatsappForm(item) {
    this.whatsappFormOpen = true;
    this.whatsappItem = item;
  }

  private closeWhatsappForm() {
    this.whatsappFormOpen = false;
    this.whatsappItem = null;
  }

  private onWhatsappSent() {
    this.closeWhatsappForm();
    this.search(false);
  }
}
